var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "progress_wrap" },
    [
      _c("div", { staticClass: "text", style: _vm.textStyle }, [
        _vm._v(_vm._s(_vm.value) + "%")
      ]),
      _vm._v(" "),
      _c("el-progress", {
        staticClass: "progress",
        attrs: { percentage: _vm.value, "show-text": false }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-703aff19", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-703aff19","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/component/progress.vue
// module id = null
// module chunks = 